import { render, staticRenderFns } from "./SearchGallery.vue?vue&type=template&id=37c95dcd&scoped=true"
import script from "./SearchGallery.vue?vue&type=script&lang=js"
export * from "./SearchGallery.vue?vue&type=script&lang=js"
import style0 from "./SearchGallery.vue?vue&type=style&index=0&id=37c95dcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c95dcd",
  null
  
)

export default component.exports